import { SCHEMA_VERSION } from "./events";

/** gtag collect hits larger than 8192 bytes are rejected with HTTP 413. */
const GA4_VIEW_ITEM_LIST_ITEM_LIMIT = 20;

/** Canonical → GA4 event name (must match fansfirst2/analytics/ga4.py). */
export const GA4_EVENT_MAP = {
  game_selected: "select_item",
  listing_selected: "select_item",
  listings_viewed: "view_item_list",
  checkout_started: "begin_checkout",
  payment_method_selected: "add_payment_info",
  account_created: "sign_up",
  login_completed: "login",
  purchase_completed: "purchase",
  refund_completed: "refund",
  order_cancelled: "order_cancelled",
};

export function mapToGa4Event(canonicalName) {
  return GA4_EVENT_MAP[canonicalName] || canonicalName;
}

function mapItem(item) {
  if (!item || typeof item !== "object") {
    return null;
  }
  const mapped = {};
  if (item.id != null) {
    mapped.item_id = String(item.id);
  }
  if (item.name != null) {
    mapped.item_name = String(item.name);
  }
  if (item.brand != null) {
    mapped.item_brand = String(item.brand);
  }
  if (item.category != null) {
    mapped.item_category = String(item.category);
  }
  if (item.price != null && !Number.isNaN(Number(item.price))) {
    mapped.price = Number(item.price);
  }
  if (item.quantity != null && !Number.isNaN(Number(item.quantity))) {
    mapped.quantity = Number(item.quantity);
  }
  if (!mapped.item_id && !mapped.item_name) {
    return null;
  }
  return mapped;
}

function mapItems(items) {
  if (!Array.isArray(items)) {
    return [];
  }
  return items.map(mapItem).filter(Boolean);
}

export function buildGa4Params(canonicalName, properties, context) {
  const ga4Name = mapToGa4Event(canonicalName);
  const params = {
    schema_version: SCHEMA_VERSION,
    language: context.language,
    page_type: context.pageType,
    anonymous_id: context.anonymousId,
    source: "web",
  };

  const props = { ...(properties || {}) };
  const mappedItems = mapItems(props.items);
  const items =
    canonicalName === "listings_viewed"
      ? mappedItems.slice(0, GA4_VIEW_ITEM_LIST_ITEM_LIMIT)
      : mappedItems;
  delete props.items;

  Object.keys(props).forEach((key) => {
    if (
      key === "value" &&
      (canonicalName === "filter_applied" ||
        canonicalName === "filter_cleared" ||
        canonicalName === "filter_results_updated")
    ) {
      params.filter_value = props[key];
      return;
    }
    if (props[key] !== undefined && props[key] !== null) {
      params[key] = props[key];
    }
  });

  if (items.length > 0) {
    params.items = items;
  }

  if (canonicalName === "game_selected") {
    if (props.target === "date_opponent") {
      delete params.value;
      if (params.items && params.items[0]) {
        delete params.items[0].price;
      }
    }
    params.item_list_id = "games";
  }

  if (canonicalName === "listings_viewed") {
    params.item_list_id = props.game_id;
    params.item_list_name = props.team;
  }

  if (canonicalName === "payment_method_selected" && props.method) {
    params.payment_type = props.method;
  }

  if (
    canonicalName === "checkout_started" ||
    canonicalName === "payment_method_selected" ||
    canonicalName === "listing_selected" ||
    canonicalName === "game_selected"
  ) {
    if (props.currency) {
      params.currency = props.currency;
    }
  }

  if (props.currency && !params.currency) {
    params.currency = props.currency;
  }

  return { ga4Name, params };
}
